import { Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

import { UmbracoHttpClient } from "@e-forsyning/common/http";

import { SmsServiceIndstillinger } from "../model/sms-service-indstillinger.model";

@Injectable({ providedIn: "root" })
export class SmsServiceRepository {
    constructor(private readonly sanitizer: DomSanitizer, private readonly umbracoHttpClient: UmbracoHttpClient) {}

    public hentIndstillinger(): Observable<SmsServiceIndstillinger> {
        return this.umbracoHttpClient.hentSideData("sms-service").pipe(
            map((result) => ({
                sideTitel: result.menuTekst,
                blueIdeaId: result.blueIdeaID,
                blueIdeaUrl: this.sanitizer.bypassSecurityTrustResourceUrl(
                    `https://dk.sms-service.dk/iFrame/subscription?customerId=${result.blueIdeaID}`
                )
            })),
            shareReplay(1)
        );
    }
}
